// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"7ef33c68","674":"d59c2805"}[chunkId] + ".chunk.js";
};